import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { forwardRef } from "react";
const SvgChevronLeft = (props, ref) => /* @__PURE__ */ React.createElement(Svg, { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", ref, ...props }, /* @__PURE__ */ React.createElement(Path, { d: "M20 12H4M4 12L10 6M4 12L10 18", strokeLinejoin: "round", strokeLinecap: "round", stroke: "currentColor", fill: "none", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgChevronLeft);
export default ForwardRef;
